import { t } from '../../app/i18n';

export default {
  SINGLE: 'SINGLE',
  DIVORCED: 'DIVORCED',
  MARRIED: 'MARRIED',
  WIDOW: 'WIDOW',
};

export const translation = {
  SINGLE: t('Slobodný/á'),
  DIVORCED: t('Rozvedený/á'),
  MARRIED: t('Ženatý/vydatá'),
  WIDOW: t('Vdovec/vdova'),
};



// WEBPACK FOOTER //
// ./src/common/enums/maritalStatuses.js